import { createSlice } from '@reduxjs/toolkit';

type InitialType = {
  selectedTasks: number[];
  isDirty: boolean;
};

const initialState: InitialType = {
  selectedTasks: [],
  isDirty: false,
};

export const sprintsSlice = createSlice({
  name: 'sprints',
  initialState,
  reducers: {
    setSelectedTasks(state, { payload }) {
      return {
        ...state,
        selectedTasks: [...payload],
      };
    },
    setDirty(state) {
      return {
        ...state,
        isDirty: true,
      };
    },
    resetDirty(state) {
      return {
        ...state,
        isDirty: false,
      };
    },
  },
});

export const sprintsReducer = sprintsSlice.reducer;
export const stateName = sprintsSlice.name;
